module.exports = __webpack_public_path__ + "static/ef9622d7.left.png";